import { SettingPageTabs } from '@aibees/shared/components/setting-page-tabs';
import { classnames } from '@aibees/shared/utils';
import { CardContent, CardHeader, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { BillingProfileProps as Props } from './types';

export const BillingProfile = memo(({ className, config }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('BillingProfile', className)}
      sx={SX.root}
      variant="outlined"
      headerDivider
    >
      <CardHeader
        title={
          <Typography fontSize="body1" fontWeight={700} color="grey.700">
            Billing
          </Typography>
        }
      />

      <CardContent>
        <SettingPageTabs config={config} tabsContainerSx={SX.tabsContainer} />
      </CardContent>
    </Styled.Wrapper>
  );
});

BillingProfile.displayName = 'BillingProfile';
